<template>
	<section class="section">
		<div class="container-fluid">
			<card ref="card" title="" icon="">
				<form-field label="タイトル" sub="必須" :has-wrap="false">
					<div class="field">
						<p class="control is-expanded">
							<input class="input" :class="{'is-danger': $utils.hasError(errors, 'title')}" type="text" v-model="title">
						</p>
						<p slot="help" class="help is-danger" v-show="$utils.hasError(errors, 'title')">{{ errors.title }}</p>
					</div>
				</form-field>

				<form-field label="会社名" sub="" :has-wrap="false">
					<div class="field">
						<p class="control is-expanded">
							<input class="input" type="text" v-model="companyName">
						</p>
					</div>
				</form-field>

				<form-field label="雇用形態" sub="" :has-wrap="false">
					<div class="field">
						<b-select v-model="employmentTypeId">
							<option value="">未選択</option>
							<option
								v-for="row in employmentTypes"
								:value="row.id"
								:key="row.id">
								{{ row.name }}
							</option>
						</b-select>
					</div>
				</form-field>

				<form-field label="業種" sub="" :has-wrap="false">
					<div class="field">
						<b-select v-model="industryTypeId">
							<option value="">未選択</option>
							<option
								v-for="row in industryTypes"
								:value="row.id"
								:key="row.id">
								{{ row.name }}
							</option>
						</b-select>
					</div>
				</form-field>

				<form-field label="職種" sub="" :has-wrap="false">
					<div class="field">
						<b-select v-model="occupationTypeId">
							<option value="">未選択</option>
							<option
								v-for="row in occupationTypes"
								:value="row.id"
								:key="row.id">
								{{ row.name }}
							</option>
						</b-select>
					</div>
				</form-field>

				<form-field label="業務内容" sub="" :has-wrap="false">
					<div class="field">
						<p class="control is-expanded">
							<textarea class="textarea" v-model="body" rows="10"></textarea>
						</p>
					</div>
				</form-field>

				<form-field label="給与" sub="" :has-wrap="false">
					<div class="field">
						<p class="control is-expanded">
							<textarea class="textarea" v-model="salary" rows="3"></textarea>
						</p>
					</div>
				</form-field>

				<form-field label="電話番号" sub="" :has-wrap="false">
					<div class="field">
						<p class="control is-expanded">
							<textarea class="textarea" v-model="tel" rows="2"></textarea>
						</p>
					</div>
				</form-field>

				<form-field label="画像" sub="" :has-wrap="false">
					<div class="field">
						<p class="control is-expanded">
							<b-upload @input="onImageChange" v-model="image">
								<a class="button is-info">
									<b-icon icon="upload"></b-icon>
									<span>画像を追加</span>
								</a>
							</b-upload>

							<div v-show="images.length >= 2" class="mt-10">ドラッグで並べ替えできます</div>

							<draggable
								class="image-list mt-20"
								@end="onEnd"
								v-model="images"
								>
								<div class="image-wrap" v-for="(row, index) in images" :key="'image' + index">
									<preview :image="row" :maxH="200" :isDeleteButtonShow="true" @delete-click="onImageRemoveClick(index)"></preview>
								</div>
							</draggable>

							<loader class="mt-20" v-show="isImageLoading"></loader>
						</p>
					</div>
				</form-field>

				<form-field label="" sub="" :has-wrap="false">
					<div class="field mt-20">
						<p class="control is-expanded">
							<b-checkbox v-model="isPublish">この求人を公開する</b-checkbox>
						</p>
					</div>
				</form-field>

				<form-field :has-wrap="false">
					<div class="edit-buttons">
						<b-button type="is-light" @click="$router.go(-1)">戻る</b-button>
						<b-button type="is-success" :loading="isLoading" @click="onRegisterButtonClick">登録</b-button>
					</div>
				</form-field>
			</card>
		</div>
	</section>
</template>

<script>
import draggable from 'vuedraggable'
import Card from '@/components/Card'
import FormField from '@/components/FormField'
import RadioPicker from "@/components/RadioPicker";
import CheckboxPicker from "@/components/CheckboxPicker";
import Preview from "@/components/Preview";
import Loader from "@/components/Loader";

export default {
	name: "job-edit",
	components: {
		RadioPicker,
		Card,
		FormField,
		CheckboxPicker,
		Preview,
		draggable,
		Loader,
	},
	data() {
		return {
			id: '',
			title: '',
			body: '',
			salary: '',
			companyName: '',
			tel: '',
			isPublish: true,
			employmentTypeId: '',
			industryTypeId: '',
			occupationTypeId: '',
			isLoading: false,
			errors: {
				title: '',
			},
			images: [],
			employmentTypes: [],
			industryTypes: [],
			occupationTypes: [],
			isImageLoading: false,
			image: null,
		}
	},
	computed: {
	},
	mounted() {
		let subTitle = this.$route.params.jobId ? '更新' : '新規作成';
		this.$store.commit('basic', {
			key: 'titleBarTitleStack',
			value: ['求人管理', subTitle]
		})
		this.getData();
	},
	methods: {
		onImageRemoveClick: function(index) {
			this.images.splice(index, 1);
		},
		// Element dragging ended
		onEnd: function (/**Event*/evt) {
			this.images = [];
			for (let i = 0; i < evt.to.children.length; i++) {
				this.$utils.log(evt.to.children[i].getElementsByTagName('img')[0].src);
				this.images.push(evt.to.children[i].getElementsByTagName('img')[0].src);
				//this.$utils.log(evt.to.children[i].children.item(0).src);
			}
		},
		onImageChange: function() {
			this.$utils.log(this.image);
			if (!this.image || !this.image.type.match(/^image\/(png|jpeg|jpg)$/)) {
				alert('画像ファイルを指定してください');
				return;
			}

			let reader = new FileReader();
			reader.readAsDataURL(this.image);
			reader.onload = (e) => {
				this.uploadImage(e.target.result);
			};
		},
		uploadImage: async function(file) {
			this.isImageLoading = true;

			let data = {
				image: file,
			};

			let ep = 'images';

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.images.push(res.data.url);
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
			} finally {
				this.isImageLoading = false;
			}
		},
		getData: async function() {
			let loading = this.$loading.open();
			let params = this.$route.params.jobId ? '/' + this.$route.params.jobId : '';
			let ep = 'jobs/screen' + params;
			this.$utils.log(ep);

			try {
				let res = await this.$api.get(ep, null, true);
				this.$utils.log(res);
				this.id = res.data.id;
				this.title = res.data.title;
				this.companyName = res.data.company_name;
				this.employmentTypeId = res.data.employment_type_id;
				this.industryTypeId = res.data.industry_type_id;
				this.occupationTypeId = res.data.occupation_type_id;
				this.body = res.data.body;
				this.salary = res.data.salary;
				this.tel = res.data.tel;
				this.isPublish = res.data.is_publish;
				this.images = res.data.images;
				this.employmentTypes = res.data.employment_types;
				this.industryTypes = res.data.industry_types;
				this.occupationTypes = res.data.occupation_types;
			} catch (error) {
				this.$utils.log(error);
				this.$utils.toastError(error.response.data.message);
			} finally {
				loading.close();
			}
		},
		onRegisterButtonClick: async function() {
			for (let key in this.errors) {
				this.errors[key] = '';
			}

			this.isLoading = true;
			let data = {
				"id": this.id,
				"title": this.title,
				"company_name": this.companyName,
				"body": this.body,
				"employment_type_id": this.employmentTypeId,
				"industry_type_id": this.industryTypeId,
				"occupation_type_id": this.occupationTypeId,
				"salary": this.salary,
				"tel": this.tel,
				"is_publish": this.isPublish ? 1 : 0,
				"images": this.images,
			};
			this.$utils.log(data);

			let ep = 'jobs';
			this.$utils.log(ep);

			try {
				let res = await this.$api.post(ep, data, true);
				this.$utils.log(res);
				this.$router.push({ name: 'job' });
			} catch (error) {
				this.$utils.log(error.response);
				this.$utils.toastError(error.response.data.message);
				if (error.response.status === 400) {
					let details = error.response.data.details;
					for (let key in details) {
						this.errors[this.$utils.toCamelCase(key)] = details[key];
					}
				}
			} finally {
				this.isLoading = false;
			}
		},
	}
}
</script>

<style lang="scss" scoped>
.image-wrap {
	margin-bottom: 20px;
}
.zm-loader {
	width: 50px !important;
}
</style>
